/**
 * data-testid属性の値を一元管理する定数ファイル
 * テストで使用する要素を識別するためのIDを定義します
 */
export const TEST_IDS = {
  PROPERTY_FORM: {
    NAME: "property-form-name",
    PREFECTURE: "property-form-prefecture",
    MUNICIPALITY: "property-form-municipality",
    TOWN: "property-form-town",
    PIN_LOCATION_CONFIRM: "property-form-pin-location-confirm",
    ITEM_NUMBER: "property-form-item-number",
    IMAGES: "property-form-images",
    REMARKS: "property-form-remarks",
    PERSON_IN_CHARGE: "property-form-person-in-charge",
    MEMO: "property-form-memo",
  },
  PROPERTY_DETAIL: {
    PARKING_NAME: "property-detail-parking-name",
    LOCATION: "property-detail-location",
    ITEM_NUMBER: "property-detail-item-number",
    REMARKS: "property-detail-remarks",
    PERSON_IN_CHARGE: "property-detail-person-in-charge",
    MEMO: "property-detail-memo",
  },
  SINGLE_DOCUMENT_UPLOADER: {
    DEFAULT: "single-document-uploader-input",
  },
  MEMO_MODAL: {
    SIGN_MODAL: "sign-modal",
  },
} as const;
